import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { PathPickBasketRequestBody } from "@/features/pathpick/features/search-products/types/request-body";

const url = {
  addPathPickBasket: (companyId: number) =>
    `/buyers/${companyId}/pathpick/basket`,
};

export const pathPickSearchProductsMutationApi = {
  addPathPickBasket: async (
    companyId: number,
    body: PathPickBasketRequestBody
  ) =>
    await axiosClient.post(
      url.addPathPickBasket(companyId),
      toSnakeKeyObject(body)
    ),
};
